<template>
    <b-card v-if="isLoaded">
        <b-row align-h="between" style="text-align: center">
            <b-col cols="6" class="mb-4" style="display: flex; justify-content: flex-start; height: 40px;">
                <div @click="routeToDashboard(selectedSite.id, year)" style="font-weight: bold; font-size: 1.2em; align-self: center; cursor: pointer">{{selectedSite.name}} - {{$t('title')}}</div>
            </b-col>
            <b-col cols="4" sm="4" md="6" lg="6" xl="5" style="height: 40px; padding-right: 1.5rem">
                <b-row align-h="end">
                    <year-select @onchange="onYearChange"/>
                    <site-multi-select
                        :selectedSiteId="selectedSite.id"
                        :givenSites="filteredSites"
                        :allowEmpty="true"
                        @oninput="selectSite"
                    />
                </b-row>
            </b-col>
        </b-row>
        <div class="table-responsive scroll-content">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                <tr>
                    <th style="width: 10em">{{ $t('dataTypeColumn') }}</th>
                    <th style="width: 10em">{{ $t('startYearColumn') }}</th>
                    <th style="width: 10em">{{ $t('endYearColumn') }}</th> 
                    <th style="width: 10em">{{ $t('goalTypeColumn') }}</th>
                    <th style="width: 10em">{{ $t('goalRatioColumn') }}</th>
                    <th style="width: 10em">{{ $t('goalColumn') }}</th>
                    <th style="width: 10em">{{ $t('actualColumn') }}</th>
                    <th style="width: 10em">{{ $t('actualColumnRatio') }}</th>
                    <th style="width: 10em">{{ $t('descriptionColumn') }}</th>
                    <th style="width: 10em">{{ $t('confirmationColumn') }}</th>
                    <th v-show="canEditGoals" id="goal-last-column" style="width: 10em;"></th>
                </tr>
                </thead>
                <tbody>
                <!-- Update item view -->
                <tr v-for="goal in goals" @keyup.enter="updateItem(goal)" @keyup.esc="bindItems(rawItems)">
                    <td>
                        <div class="tableBodyCell">
                            <template>
                                <b-form-select v-model="goal.dataTypeId.editedValue" v-if="goal.editMode"
                                            :options="dataTypesDropdown"
                                            @focus.native="resetWarning(goal, 'dataTypeId')"
                                            @change="configureItemOnDataTypeChange($event, goal, false)"
                                            :class="Object.assign(goal.dataTypeId.classes, {'masked-custom-input': true, 'form-control-custom': true})"
                                            style="border-radius: unset !important; height: 100%;">
                                <option :value="null" :disabled="true">{{$t('choose')}}</option>
                            </b-form-select>
                            <div :title="$t(goal.dataTypeId.name)" v-else>
                                    {{ $t(goal.dataTypeId.name) | shortenText }}
                                </div>
                            </template>
                        </div>
                    </td>
                        <!-- data of start year is shown here -->
                    <td>
                        <div class="tableBodyCell">
                            <template>
                                <template v-if="goal.editMode">
                                    <b-form-select v-model="goal.startYear.editedValue" :options="yearChoices.startYearChoices" 
                                    @change="setSelectedBaseYear($event, goal, false /*: isTempItem = false */)" style="border-radius: unset !important; height: 100%;"/>
                                </template>
                                <div v-else>
                                    {{ (goal.startYear.editedValue ? goal.startYear.editedValue : '-')}}
                                </div>
                            </template>
                        </div>
                    </td>
                        <!-- data of end year is shown here -->
                    <td>
                        <div class="tableBodyCell">
                            <template>
                                <template v-if="goal.editMode">
                                    <b-form-select v-model="goal.endYear.editedValue" :options="yearChoices.endYearChoices"
                                    @change="setSelectedEndYear($event, goal, false /*: isTempItem = false */)" style="border-radius: unset !important; height: 100%;"/>
                                </template>
                                <div v-else>
                                    {{ (goal.endYear.editedValue ? goal.endYear.editedValue : '-') }}
                                </div>
                            </template>
                        </div>
                    </td>                    
                    <td>
                        <div class="tableBodyCell">
                            <b-form-select v-if="goal.dataTypeId.editedValue && goal.editMode"
                                            v-model="goal.direction.editedValue"
                                            @focus.native="resetWarning(goal, 'direction')"
                                            :options="goalTypes" @change="calculatesGoalValueByDirectionOnChange($event, goal)"
                                            :class="Object.assign(goal.dataTypeId.classes, {'form-control-custom': true})"
                                            style="border-radius: unset !important; height: 100%;"/>
                            <template v-else-if="goal.dataTypeId.editedValue">
                                {{ directionValueToText(goal.direction.value) }}
                            </template>
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            <template v-if="goal.direction.editedValue === 0 || goal.baseYearValue === 0">
                                -
                            </template>
                            <template v-else-if="!goal.editMode">
                                {{goal.valueR.value}}
                            </template>
                            <template v-else>
                                <masked-input
                                    v-model="goal.valueR.editedValue"
                                    :keepCharPositions="false"
                                    :pipe="pipeNumber(goal)"
                                    type="text"
                                    :mask="maskOfNumber"
                                    :placeholder="$t('goalRatioColumn')"
                                    :class="Object.assign(goal.valueR.classes, {'masked-custom-input': true, 'form-control-custom': true})"
                                    @focus="resetWarning(goal, 'valueR'); goal.lockR = false; goal.lockN=true;"
                                    @input="calculateNumber(goal)">
                                </masked-input>
                            </template>
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            <template v-if="!goal.editMode && goal.valueN.value">
                                {{goal.valueN.value || parseNumber('float', locale)}} {{$t(goal.unitName)}}
                            </template>
                            <template v-else-if="!goal.editMode && !goal.valueN.value">
                                {{ calculateGlobalValueN(goal) }}
                            </template>
                            <template v-else>
                                <masked-input
                                    v-model="goal.valueN.editedValue"
                                    :keepCharPositions="false"
                                    type="text"
                                    :mask="maskOfNumber"
                                    :placeholder="$t('goalColumn')"
                                    :class="Object.assign(goal.valueN.classes, {'masked-custom-input': true, 'form-control-custom': true})"
                                    @focus="resetWarning(goal, 'valueN'); goal.lockR = true; goal.lockN=false;"
                                    @input="calculateRatio(goal)">
                                </masked-input>
                                <small v-show="goal.valueN.hasWarn" class="form-text" style="font-size: 0.500em; color: red">{{goal.valueN.warnMessage}}</small>
                            </template>
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            {{goal.currentTotals}} {{$t(goal.unitName)}}
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            <!-- previous version: <template v-if="!goal.valueN.value | !goal.currentYearValue"> -->
                            <template v-if="goal.valueN.editedValue && goal.currentTotals">
                                {{ goal.currentTotals | toRatio(goal.valueN.editedValue) }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </div>
                    </td>
                    <td>
                        <div class="tableBodyCell">
                            <template v-if="!goal.editMode">
                                <span v-if="goal.descriptionOther.value" v-b-tooltip.hover :title="goal.descriptionOther.value" style="max-width:80px;">{{goal.descriptionOther.value | textToShortText}}</span>
                                <span v-else-if="!goal.descriptionId.value||goal.descriptionId.value&&goal.descriptionId.value.length<10">{{goal.descriptionId.value | descriptionValueToText(descriptions)}}</span>
                                <span v-else v-b-tooltip.hover :title="goal.descriptionId.value | descriptionValueToText(descriptions)">{{goal.descriptionId.value | descriptionValueToText(descriptions) | textToShortText}}</span>
                            </template>
                            <template v-else>
                                <template v-if="goal.descriptionOther.editedValue">
                                    <b-form-input
                                        @click.native="descriptionIdTemp = -1; descriptionOtherTemp = goal.descriptionOther.editedValue; $refs[`descriptionText${goal.id}`][0].show()"
                                        @focus.native="resetWarning(goal, 'descriptionOther')"
                                        :value="goal.descriptionOther.editedValue"
                                        :class="goal.descriptionOther.classes"
                                        style="cursor: pointer; background-color: white"
                                        readonly/>
                                    <small v-show="goal.descriptionOther.hasWarn" class="form-text" style="font-size: 0.500em; color: red">{{goal.descriptionOther.warnMessage}}</small>
                                </template>
                                <template v-else>
                                    <b-form-input
                                        @click.native="descriptionIdTemp = goal.descriptionId.editedValue; descriptionOtherTemp = null;$refs[`descriptionText${goal.id}`][0].show()"
                                        @focus.native="resetWarning(goal, 'descriptionId')"
                                        :value="goal.descriptionId.editedValue | descriptionValueToText(descriptions)"
                                        :class="Object.assign(goal.descriptionId.classes, {'form-control-custom': true})"
                                        style="cursor: pointer; background-color: white"
                                        readonly/>
                                    <small v-show="goal.descriptionId.hasWarn" class="form-text" style="font-size: 0.500em; color: red">{{goal.descriptionId.warnMessage}}</small>
                                </template>
                            </template>
                        </div>
                        <b-modal :ref="`descriptionText${goal.id}`" size="sm" hide-footer hide-header centered>
                            <div class="d-block text-center">
                                <b-row>
                                    <b-col>
                                        <b-form-select v-model="descriptionIdTemp" text-field="description_text" value-field="id">
                                            <option :value="null" disabled>{{ $t('choose') }}</option>
                                            <option v-for="description in descriptions" v-if="description.id !== null" :value="description.id">{{$t(description.description_text)}}</option>
                                            <option :value="-1">{{ $t('Diğer') }}</option>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row v-if="descriptionIdTemp === -1">
                                    <b-col>
                                        <b-form-textarea v-model="descriptionOtherTemp" placeholder="Açıklama girin" class="mt-3"/>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-btn size="sm" class="mt-3" variant="outline-primary" @click="setDescription(goal, descriptionIdTemp, descriptionOtherTemp)" block>Tamam</b-btn>
                        </b-modal>
                    </td>
                    <td>                        
                        <div class="tableBodyCell">
                            <template v-if="goal.editStatusOnly">
                                <b-form-select v-model="goal.isApproved.editedValue" :options="approvalTypes" style="border-radius: unset !important; height: 100%;"/>
                            </template>
                            <template v-else-if="!goal.editMode || !canApproveGoals">
                                <span>
                                    <i v-if="!goal.isApproved.value" class="fas fa-pause"></i>
                                    <i v-else class="fas fa-check"></i>
                                </span>
                            </template>
                            <template v-else>
                                <b-form-select v-model="goal.isApproved.editedValue" :options="approvalTypes" style="border-radius: unset !important; height: 100%;"/>
                            </template>
                        </div>
                    </td>
                    <td v-if="canEditGoals" :style="{width: lastColumnWidth}" class="edit-column">
                        <div class="tableBodyCell">
                            <div v-if="!goal.editMode" @click="makeRowEditable(goal.id)" style="color: #8888; cursor: pointer">
                                <i class="fas fa-edit"></i>
                            </div>
                            <div :key="'btngroup'" v-else class="table-button-group">
                                <b-button v-b-tooltip.hover :title="$t('save')" @click="updateItem(goal)"><i class="fas fa-check"></i></b-button>
                                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="cancelRow(rawItems)"><i class="fas fa-ban"></i></b-button>
                                <b-button v-b-modal.warn v-b-tooltip.hover :title="$t('delete')" @click="deleteItem($event, goal.id)"><i class="fas fa-trash-alt"></i></b-button>
                            </div>
                        </div>
                    </td>
                    <td v-else-if="canApproveGoals" :style="{width: lastColumnWidth}" class="edit-column">
                        <div class="tableBodyCell">
                            <div v-if="!goal.editStatusOnly" @click="makeRowEditable(goal.id)" style="color: #8888; cursor: pointer">
                                <i class="fas fa-edit"></i>
                            </div>
                            <div :key="'btngroup'" v-else class="table-button-group">
                                <b-button v-b-tooltip.hover :title="$t('save')" @click="updateItem(goal)"><i class="fas fa-check"></i></b-button>
                                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="cancelRow(rawItems)"><i class="fas fa-ban"></i></b-button>
                            </div>
                        </div>
                    </td>
                </tr>
                <transition name="fadere" mode="out-in">
                    <!-- Create item view -->
                    <tr v-if="insertMode" @keyup.enter="createItem()" @keyup.esc="cancelNewRow()" style="border-bottom: 1px solid #ddd">
                        <td>
                            <div class="tableBodyCell">
                                <b-form-select v-model="tempItem.dataTypeId.editedValue"
                                            :options="dataTypesDropdown"
                                            @focus.native="resetWarning(tempItem, 'dataTypeId')"
                                            @change="configureItemOnDataTypeChange($event, tempItem, true)"
                                            :class="Object.assign(tempItem.dataTypeId.classes, {'masked-custom-input': true, 'form-control-custom': true})"
                                            style="border-radius: unset !important; height: 100%;">
                                    <option :value="null" :disabled="true">{{$t('choose')}}</option>
                                </b-form-select>
                            </div>
                        </td>
                        <!-- start and end years of create view: -->
                        <td>
                            <div class="tableBodyCell">
                                <template v-if="!tempItem.dataTypeId.editedValue">
                                        -
                                </template>
                                <template v-else>
                                    <b-form-select v-model="tempItem.startYear.editedValue" :options="yearChoices.startYearChoices" 
                                    @change="setSelectedBaseYear($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <template v-if="!tempItem.dataTypeId.editedValue">
                                    -
                                </template>
                                <template v-else>
                                    <b-form-select v-model="tempItem.endYear.editedValue" :options="yearChoices.endYearChoices"
                                    @change="setSelectedEndYear($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <b-form-select v-if="tempItem.dataTypeId.editedValue"
                                            v-model="tempItem.direction.editedValue"
                                            @focus.native="resetWarning(tempItem, 'direction')"
                                            :options="goalTypes" @change="calculatesGoalValueByDirectionOnChange($event, tempItem)"
                                            :class="Object.assign(tempItem.dataTypeId.classes, {'form-control-custom': true})"
                                            style="border-radius: unset !important; height: 100%;"/>
                                <template v-else>
                                    -
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <template v-if="!tempItem.dataTypeId.editedValue || tempItem.direction.editedValue === 0">
                                    -
                                </template>
                                <template v-else>
                                    <masked-input
                                        v-model="tempItem.valueR.editedValue"
                                        :value="tempItem.valueR.editedValue"
                                        :keepCharPositions="false"
                                        :pipe="pipeNumber(tempItem)"
                                        type="text"
                                        :mask="maskOfNumber"
                                        :placeholder="$t('goalRatioColumn')"
                                        :class="Object.assign(tempItem.valueR.classes, {'form-control-custom': true})"
                                        @focus="resetWarning(tempItem, 'valueR'); tempItem.lockR = false; tempItem.lockN=true;"
                                        @input="calculateNumber(tempItem)">
                                    </masked-input>
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <template v-if="!tempItem.dataTypeId.editedValue">
                                    -
                                </template>
                                <template v-else>
                                    <masked-input
                                        v-model="tempItem.valueN.editedValue"
                                        :keepCharPositions="false"
                                        type="text"
                                        :mask="maskOfNumber"
                                        :placeholder="$t('goalColumn')"
                                        :class="Object.assign(tempItem.valueN.classes, {'form-control-custom': true})"
                                        @focus="resetWarning(tempItem, 'valueN'); tempItem.lockR = true; tempItem.lockN=false;"
                                        @input="calculateRatio(tempItem)">
                                    </masked-input>
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <template v-if="!tempItem.dataTypeId.editedValue">
                                    -
                                </template>
                                <template v-else>
                                    {{tempItem.currentYearValue | parseNumber('float', locale)}} {{$t(tempItem.unitName)}}
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <template>
                                    -
                                </template>
                            </div>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                <template  v-if="tempItem.descriptionOther.editedValue">
                                    <b-form-input
                                        @click.native="resetWarning(tempItem, 'descriptionOther');descriptionIdTemp=null; descriptionOtherTemp=null; $refs.descriptionTextTemp.show()"
                                        :value="tempItem.descriptionOther.editedValue"
                                        :class="Object.assign(tempItem.descriptionOther.classes, {'form-control-custom': true})"
                                        style="cursor: pointer; background-color: white"
                                        readonly/>
                                </template>
                                <template v-else>
                                    <b-form-input
                                        @click.native="resetWarning(tempItem, 'descriptionId'); descriptionIdTemp=null; descriptionOtherTemp=null;$refs.descriptionTextTemp.show()"
                                        :value="tempItem.descriptionId.editedValue | descriptionValueToText(descriptions)"
                                        :class="Object.assign(tempItem.descriptionId.classes, {'form-control-custom': true})"
                                        style="cursor: pointer; background-color: white"
                                        readonly/>
                                </template>
                            </div>
                            <b-modal ref="descriptionTextTemp" size="sm" hide-footer hide-header centered>
                                <div class="d-block text-center">
                                    <b-row>
                                        <b-col>
                                            <b-form-select v-model="descriptionIdTemp" text-field="description_text" value-field="id" :options="descriptions">
                                                <option :value="-1">{{ $t('Diğer') }}</option>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="descriptionIdTemp === -1">
                                        <b-col>
                                            <b-form-textarea v-model="descriptionOtherTemp" placeholder="Açıklama girin" class="mt-3"></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-btn size="sm" class="mt-3" variant="outline-primary" @click="setDescription(tempItem, descriptionIdTemp, descriptionOtherTemp)" block>{{$t('save')}}</b-btn>
                            </b-modal>
                        </td>
                        <td>
                            <div class="tableBodyCell">
                                -
                            </div>
                        </td>
                        <td class="edit-column " :style="{width: lastColumnWidth}">
                            <div class="table-button-group">
                                <b-button v-b-tooltip.hover :title="$t('save')" @click="createItem()" style="mso-border-shadow: no"><i class="fas fa-check"></i></b-button>
                                <b-button v-b-tooltip.hover :title="$t('cancel')" @click="cancelNewRow()"><i class="fas fa-ban"></i></b-button>
                            </div>
                        </td>
                    </tr>
                </transition>
                </tbody>
                <tfoot class="insert-row">
                    <tr v-if="!insertMode && canCreateGoals" @click="insertRow()" >
                        <td style="border: 1px solid #ddd" colspan="11">
                            <div class="tableBodyCell">
                                <div style="bottom: 56px; left: 0; right: 0; margin:auto;padding: 15px;">
                                    <i class="fas fa-plus-circle fa-2x"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </b-card>
    <div v-else></div>
</template>

<script>
import _ from 'lodash';
import qs from 'qs';
import globalFilters from '../../filters';
import Multiselect from 'vue-multiselect';
import YearSelect from '../../components/YearSelect';
import SiteMultiSelect from '../../components/SiteMultiSelect';

export default {
    name: 'goal-detail',
    components: {SiteMultiSelect, YearSelect, Multiselect},
    data() {
        return {
            canEditGoals: this.$store.state.user.permissions.canEditGoals,
            canCreateGoals: this.$store.state.user.permissions.canCreateGoals,
            canApproveGoals: this.$store.state.user.permissions.canApproveGoals,
            descriptionIdTemp: null, // Temporary descriptionId is used in Modal actions
            descriptionOtherTemp: null, // Temporary descriotionOther is used in Modal actions
            isLoaded: false, // Toggles page loading
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin
            goals: [],
            baseYear: 2015,
            currentYear: new Date().getFullYear(),
            rollbackRow: [],

            allTotals: [],
            rawItems: [], // Original goal object array
            descriptions: [],
            units: [],
            dataTypes: [],
            dataTypesDropdown: [],
            siteProperties: [], // current site properties to identify site details (area,number of workers etc.)
            tempItem: {}, // Temporary object used for inserts
            goalTypes: [
                {
                    value: 0,
                    text: this.$t('currentSituation')
                },
                {
                    value: -1,
                    text: this.$t('decrease')
                },
                {
                    value: 1,
                    text: this.$t('raise')
                }
            ],
            approvalTypes: [
                {
                    value: 0,
                    text: this.$t('noConfirm')
                },
                {
                    value: 1,
                    text: this.$t('confirm')
                }
            ],
            yearChoices: {
                startYearChoices: [
                    {
                        value: `${new Date().getFullYear() - 5}`,
                        text: `${new Date().getFullYear() - 5}`
                    },
                    {
                        value: `${new Date().getFullYear() - 4}`,
                        text: `${new Date().getFullYear() - 4}`
                    },
                    {
                        value: `${new Date().getFullYear() - 3}`,
                        text: `${new Date().getFullYear() - 3}`
                    },
                    {
                        value: `${new Date().getFullYear() - 2}`,
                        text: `${new Date().getFullYear() - 2}`
                    },
                    {
                        value: `${new Date().getFullYear() - 1}`,
                        text: `${new Date().getFullYear() - 1}`
                    }
                ],
                endYearChoices: [
                    {
                        value: `${new Date().getFullYear()}`,
                        text: `${new Date().getFullYear()}`
                    },
                    {
                        value: `${new Date().getFullYear() + 1}`,
                        text: `${new Date().getFullYear() + 1}`
                    },
                    {
                        value: `${new Date().getFullYear() + 2}`,
                        text: `${new Date().getFullYear() + 2}`
                    },
                    {
                        value: `${new Date().getFullYear() + 3}`,
                        text: `${new Date().getFullYear() + 3}`
                    },
                    {
                        value: `${new Date().getFullYear() + 4}`,
                        text: `${new Date().getFullYear() + 4}`
                    },
                    {
                        value: `${new Date().getFullYear() + 5}`,
                        text: `${new Date().getFullYear() + 5}`
                    }
                ]
            },
            insertMode: false,
            lastColumnWidth: '140px'
        };
    },

    filters: {
        toRatio(dividend, divider) {
            divider = Number(divider.replace('.', '').replace(',', '.'));
            dividend = Number(
                String(dividend)
                    .replace('.', '')
                    .replace(',', '.')
            );
            return divider && dividend !== Infinity
                ? (100 * ((dividend - divider) / divider)).toFixed(0)
                : '-';
        },
        descriptionValueToText(val, descriptions) {
            return _.get(_.find(descriptions, {id: val}), 'description_text');
        },
        textToShortText(val) {
            if (val && val.length > 25) {
                return `${val.slice(0, 25)}...`;
            } else {
                return val;
            }
        }
    },

    methods: {
        onYearChange(newYear) {
            this.isLoaded = false;
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'goal-detail',
                params: {site_id: this.route.params.site_id},
                query: {year: this.year}
            });
            this.init();
        },
        setSelectedBaseYear(val, item, isTempItem = true) {
            item.startYear.editedValue = val;
            this.setTotalsByDataType(_.get(item, 'dataTypeId.editedValue'), item, isTempItem);
        },
        setSelectedEndYear(val, item, isTempItem = true) {
            item.endYear.editedValue = val;
            this.setTotalsByDataType(_.get(item, 'dataTypeId.editedValue'), item, isTempItem);
        },
        selectSite(site) {
            if (!site) {
                this.$router.push({name: 'goal', query: {year: this.year}});
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                this.$router.push({
                    name: 'goal-detail',
                    params: {site_id: site.id},
                    query: {
                        year: this.year
                    }
                });
                this.dataTypes = this.$store.state.dataTypes.filter(dataType => {
                    return this.selectedSite.dataTypes.indexOf(dataType.id) > -1;
                });
                this.listSiteGoals();
            }
        },
        directionValueToText(val) {
            if (val === 0) {
                return this.$t('currentSituation');
            } else if (val === -1) {
                return this.$t('decrease');
            } else {
                return this.$t('raise');
            }
        },
        // Sets temporary description value to origin goal object after modal is applied.
        setDescription(goal, descriptionIdTemp, descriptionOtherTemp) {
            if (descriptionIdTemp === -1) {
                goal.descriptionOther.editedValue = descriptionOtherTemp;
                goal.descriptionId.editedValue = null;
            } else {
                goal.descriptionId.editedValue = descriptionIdTemp;
                goal.descriptionOther.editedValue = null;
            }

            if (goal.id) {
                this.$refs[`descriptionText${goal.id}`][0].hide();
            } else {
                this.$refs.descriptionTextTemp.hide();
            }
        },

        pipeNumber(item) {
            return conformedValue => {
                if (item.direction.editedValue === -1) {
                    let unlocalizedConformedValue = Number(
                        this.delocalizeValue(item.valueR.editedValue, this.locale)
                    );
                    return unlocalizedConformedValue > 100 ? '100' : conformedValue;
                } else {
                    return conformedValue;
                }
            };
        },

        calculateRatio(item) {
            if (!item.lockN && item.baseYearValue>0) {
                let delocalizedNumber = Number(
                    this.delocalizeValue(item.valueN.editedValue, this.locale)
                    .replace('.', '')
                    .replace(',', '.')
                );
                let calculatedRatio = Number(
                    (delocalizedNumber / item.baseYearValue * 100).toFixed(2)
                );
                if (calculatedRatio > 100) {
                    item.valueR.editedValue = this.convertToLocalizedFloat(
                        calculatedRatio - 100,
                        this.locale
                    );
                    item.direction.editedValue = +1;
                } else if (calculatedRatio < 100) {
                    item.valueR.editedValue = this.convertToLocalizedFloat(
                        100 - calculatedRatio,
                        this.locale
                    );
                    item.direction.editedValue = -1;
                } else {
                    item.valueR.editedValue = '0';
                    item.direction.editedValue = 0;
                }
            }
        },
        filterDeletedDataTypes(siteId) {
           this.$Progress.start();
            return this.axios.get(`/data/${siteId}/deleted_data/?${qs.stringify({year: this.year})}`).then(({data}) => {
                this.dataTypesDropdown = _.filter(this.dataTypesDropdown, dataType => !_.includes(data, dataType.value));
                return this.$Progress.finish();
            });
        },
        calculateNumber(item) {
            if (!item.lockR && item.baseYearValue>0) {
                let deLocalizedRatio = Number(
                    this.delocalizeValue(item.valueR.editedValue, this.locale)
                        .replace('.', '')
                        .replace(',', '.')
                );
                if (item.direction.editedValue === -1) {
                    deLocalizedRatio = deLocalizedRatio > 100 ? 100 : deLocalizedRatio;
                }
                let calculated = (
                    item.baseYearValue +
                    item.direction.editedValue * (item.baseYearValue * (deLocalizedRatio / 100))
                ).toFixed(2);
                item.valueN.editedValue = globalFilters.parseNumber(
                    calculated,
                    'float',
                    this.locale
                );
            }
        },

        calculateGlobalValueN(item) {
            let deLocalizedRatio = Number(
                this.delocalizeValue(item.valueR.editedValue, this.locale)
                    .replace('.', '')
                    .replace(',', '.')
            );
            if (item.direction.editedValue === -1) {
                deLocalizedRatio = deLocalizedRatio > 100 ? 100 : deLocalizedRatio;
            }
            
            if(item.baseYearValue>0){
                let calculated = (
                    item.baseYearValue +
                    item.direction.editedValue * (item.baseYearValue * (deLocalizedRatio / 100))
                ).toFixed(2);
                item.valueN.editedValue = globalFilters.parseNumber(calculated, 'float', this.locale);
            }
            
            return item.valueN.editedValue;
        },
        //Normalize current and last year values by dividing total values by area and/or staff count.
        normalizeTotals(item, val, baseArea, baseStaffCount, currentArea, currentStaffCount) {
            let dataTypeId = item.dataTypeId.editedValue;
            let dataType = _.find(this.$store.state.dataTypes, {id: dataTypeId})
            let dataTypeName = _.get(dataType, 'name');
            let normalizationType = _.get(dataType, 'normalizationType');
            switch(normalizationType){
                case 'area':
                    item.baseYearValue = item.baseConsumption / baseArea;
                    item.currentTotals = globalFilters.parseNumber(
                        item.currentConsumption / currentArea || 0,
                        'float',
                        this.locale
                    );
                    item.unitName = this.$t(item.unitName) + '/m²';
                    break;
                case 'person':
                    item.baseYearValue = item.baseConsumption / baseStaffCount;
                    item.currentTotals = globalFilters.parseNumber(
                        item.currentConsumption / currentStaffCount || 0,
                        'float',
                        this.locale
                    );
                    item.unitName = this.$t(item.unitName) + this.$t('perPerson');
                    break;
                default:
                    item.baseYearValue = item.baseConsumption ? item.baseConsumption : 0;
                    item.currentTotals = globalFilters.parseNumber(
                        item.currentConsumption || 0,
                        'float',
                        this.locale
                    );
                    if(dataTypeName === 'uncoated-groundwood' ||
                    dataTypeName === 'uncoated-groundwood(block)' ||
                    dataTypeName === 'uncoated-freesheet' ||
                    dataTypeName === 'uncoated-freesheet(package)'
                    ){
                        item.unitName = this.$t(item.unitName) + '/'+this.$t('ay');
                    }
                    break;
            }
            if(item.baseYearValue>0){
                item.valueN.value = globalFilters.parseNumber(
                    item.valueR.value && item.direction.value
                        ? item.baseYearValue +
                        Number(item.valueR.value.includes(',')
                            ? item.valueR.value.replace('.', '').replace(',', '.')
                            : item.valueR.value) *
                            item.baseYearValue /
                            100 *
                            item.direction.value
                        : item.baseYearValue,
                    'float',
                    this.locale
                );
                item.valueN.editedValue = globalFilters.parseNumber(
                    item.valueR.value && item.direction.value
                        ? item.baseYearValue +
                        Number(item.valueR.value.includes(',')
                            ? item.valueR.value.replace('.', '').replace(',', '.')
                            : item.valueR.value) *
                            item.baseYearValue /
                            100 *
                            item.direction.value
                        : item.baseYearValue,
                    'float',
                    this.locale
                );
            }else{
                item.valueN.editedValue = item.valueN.value;
            }
        },

        // Set current and last year totals
        setTotalsByDataType(val, item, isTempItem) {
            let itemCurrentYear = Number(item.endYear.editedValue);
            let currentYear = new Date().getFullYear();
            currentYear = currentYear < itemCurrentYear ? currentYear : itemCurrentYear;
            let baseYear = Number(_.get(item, 'startYear.editedValue')) || 2015;
            let baseYearData = _.find(this.allTotals, {year: Number(item.startYear.editedValue)});
            let currentYearData = _.find(this.allTotals, {year: currentYear});
            let baseConsumption = Number(
                _.get(_.find(_.get(baseYearData, 'values'), {type_id: val}), 'sum_1')
            );
            item.baseConsumption = baseConsumption || 0;
            let currentConsumption = Number(
                _.get(_.find(_.get(currentYearData, 'values'), {type_id: val}), 'sum_1')
            );
            item.currentConsumption = currentConsumption || 0;

            let currentArea =
                _.get(
                    _.find(this.siteProperties, {
                        year: currentYear || new Date().getFullYear()
                    }),
                    'area'
                ) || 0;
            let tempCurrentYear = currentYear;
            while (tempCurrentYear >= 2015 && (!currentArea || currentArea === 0)) {
                currentArea = _.get(
                    _.find(this.siteProperties, {
                        year: tempCurrentYear || new Date().getFullYear()
                    }),
                    'area'
                );
                --tempCurrentYear;
            }
            let currentStaffCount =
                _.get(
                    _.find(this.siteProperties, {
                        year: currentYear || new Date().getFullYear()
                    }),
                    'staff_count'
                ) || 0;
            let baseArea =
                _.get(
                    _.find(this.siteProperties, {
                        year: baseYear
                    }),
                    'area'
                ) || 0;
            let tempBaseYear = baseYear;
            while (tempBaseYear >= 2015 && (!baseArea || baseArea === 0)) {
                baseArea = _.get(
                    _.find(this.siteProperties, {
                        year: tempBaseYear || 2015
                    }),
                    'area'
                );
                --tempBaseYear;
            }
            let baseStaffCount =
                _.get(
                    _.find(this.siteProperties, {
                        year: baseYear
                    }),
                    'staff_count'
                ) || 0;
            let foundUnitId = _.get(_.find(this.dataTypes, {id: val}), 'unit_id_1');
            item.unitName = _.get(_.find(this.units, {id: foundUnitId}), 'name');
            this.normalizeTotals(
                item,
                val,
                baseArea,
                baseStaffCount,
                currentArea,
                currentStaffCount
            );
            if (isTempItem) {
                this.tempItem = item;
            }
        },

        // Configures the goal object when data type is changed
        configureItemOnDataTypeChange(val, item, isTempItem) {
            if (isTempItem) {
                this.bindTempItemToView();
            }
            item.dataTypeId.editedValue = val;
            this.setTotalsByDataType(val, item, isTempItem);
            this.calculatesGoalValueByDirectionOnChange(item.direction.editedValue, item);
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },

        // Calculates goal value when direction is changed
        calculatesGoalValueByDirectionOnChange(val, item) {
            item.direction.editedValue = val;
            if (val === 0) {
                item.valueN.editedValue = globalFilters.parseNumber(
                    item.baseYearValue.toFixed(2),
                    'float',
                    this.locale
                );
            } else {
                let deLocalizedRatio = this.convertToNumber(item.valueR.editedValue);
                item.valueN.editedValue = globalFilters.parseNumber(
                    (
                        item.baseYearValue +
                        val * (item.baseYearValue * (deLocalizedRatio / 100))
                    ).toFixed(2),
                    'float',
                    this.locale
                );
            }
        },

        insertRow() {
            this.insertMode = true;
            this.bindTempItemToView();
            this.bindItems(this.rawItems);
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },

        cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },

        cancelRow() {
            Object.assign(this.allTotals, this.rollbackRow);
            this.bindItems(this.rawItems);
            this.goals = _.map(this.goals, goal => {
                goal.editMode = false;
                goal.editStatusOnly = false;
                return goal;
            });
        },

        makeRowEditable(goalId) {
            this.cancelNewRow();
            this.bindItems(this.rawItems);
            let goal = _.find(this.goals, {id: goalId});
            Object.assign(this.rollbackRow, this.allTotals);
            if(this.canEditGoals){
                goal.editMode = true;
            }
            else if(this.canApproveGoals){
                goal.editStatusOnly = true;
            }
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },

        resetWarning(item, key) {
            item[key].classes['is-invalid'] = false;
            item[key].hasWarn = false;
        },

        bindTempItemToView() {
            let tempItem = {
                descriptionId: {editedValue: null},
                descriptionOther: {editedValue: null},
                baseYearValue: 0,
                startYear: {editedValue: 0},
                endYear: {editedValue: 0},
                currentYearValue: 0,
                direction: {editedValue: 0},
                dataTypeId: {editedValue: null},
                valueN: {editedValue: '0'},
                valueR: {editedValue: '0'},
                isApproved: {editedValue: 0},
                unitName: ''
            };

            for (let key in tempItem) {
                if (typeof tempItem[key] === 'object') {
                    tempItem[key].required = true;
                    tempItem[key].hasWarn = false; // toggles warning message
                    tempItem[key].lockN = false; // Number Field and Ratio Field calculates one another and it causes infinite loop. If value is true then Number field is locked for calculation.
                    tempItem[key].lockR = false; // Number Field and Ratio Field calculates one another and it causes infinite loop. If value is true then Ratio field is locked for calculation.
                    tempItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    tempItem[key].warnMessage = this.$t('required');
                }
            }

            this.tempItem = tempItem;
        },

        isItemValid(item) {
            let isValid = true;

            if (_.isNil(item.valueN.editedValue)) {
                item.valueN.classes['is-invalid'] = true;
                item.valueN.hasWarn = true;
                isValid = false;
            }

            if (_.isNil(item.dataTypeId.editedValue)) {
                item.dataTypeId.classes['is-invalid'] = true;
                item.dataTypeId.hasWarn = true;
                isValid = false;
            }

            return isValid;
        },
        // @mehmetcalim: with new design(base-start-end years etc.) create-update-delete-prepare functions will be changed.
        createItem() {
            if (this.isItemValid(this.tempItem)) {
                let arrangedItem = {
                    startYear: this.tempItem.startYear.editedValue,
                    endYear: this.tempItem.endYear.editedValue,
                    siteId: Number(_.get(this.route.params, 'site_id')),
                    dataTypeId: this.tempItem.dataTypeId.editedValue,
                    descriptionId: this.tempItem.descriptionId.editedValue,
                    descriptionOther: this.tempItem.descriptionOther.editedValue,
                    direction: this.tempItem.direction.editedValue,
                    isApproved: this.tempItem.isApproved.editedValue,
                    valueN: Number(
                        this.delocalizeValue(this.tempItem.valueN.editedValue, this.locale)
                            .replaceAll('.', '')
                            .replaceAll(',', '.')
                    ),
                    valueR: Number(
                        this.delocalizeValue(this.tempItem.valueR.editedValue, this.locale)
                            .replace('.', '')
                            .replace(',', '.')
                    ),
                    typeUnitId: 1
                };

                this.$Progress.start();
                return this.axios.post('/goals', arrangedItem).then(({data}) => {
                    let result = data;
                    this.rawItems.push(result);
                    this.bindItems(this.rawItems);
                    this.cancelNewRow();
                    this.init();
                    return this.$Progress.finish();
                });
            }
        },

        updateItem(goal) {
            if (this.isItemValid(goal)) {
                let arrangedItem = {
                    startYear: goal.startYear.editedValue,
                    endYear: goal.endYear.editedValue,
                    dataTypeId: goal.dataTypeId.editedValue,
                    direction: goal.direction.editedValue,
                    valueN: Number(
                        this.delocalizeValue(goal.valueN.editedValue, this.locale)
                            .replaceAll('.', '')
                            .replaceAll(',', '.')
                    ),
                    valueR: Number(
                        this.delocalizeValue(goal.valueR.editedValue, this.locale)
                            .replace('.', '')
                            .replace(',', '.')
                    ),
                    descriptionId: goal.descriptionId.editedValue,
                    descriptionOther: goal.descriptionOther.editedValue,
                    isApproved: goal.isApproved.editedValue,
                    typeUnitId: 1
                };

                this.$Progress.start();
                return this.axios.put(`/goals/${goal.id}`, arrangedItem).then(({data}) => {
                    let result = data;
                    let rawItem = _.find(this.rawItems, {id: goal.id});
                    goal.editMode = false;
                    goal.editStatusOnly = false;
                    Object.assign(rawItem, result);
                    this.bindItems(this.rawItems);
                    return this.$Progress.finish();
                });
            }
        },

        deleteItem(event, id) {
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios.delete(`/goals/${id}`).catch(() => {
                    this.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                    this.listSiteGoals();
                });
                this.rawItems = this.rawItems.filter(item => {
                    return item.id !== id;
                });
                this.bindItems(this.rawItems);
            });
        },

        // Prepare a goal object to use in dom
        prepareItem(item) {
            if (this.allTotals && new Date(item.start_date).getFullYear() === this.allTotals.year) {
                item.value_n = _.find(this.allTotals.values, {type_id: item.data_type_id});
            }
            let configuredItem = {
                currentTotals: _.get(item, 'currentTotals.sum_1')
            };
            var startDateInit;
            var endDateInit;
            startDateInit =
                item.start_date != null
                    ? item.start_date.substr(0, item.start_date.indexOf('-'))
                    : '-';
            endDateInit =
                item.end_date != null ? item.end_date.substr(0, item.end_date.indexOf('-')) : '-';

            configuredItem.editMode = _.get(_.find(this.goals, {id: item.id}), 'editMode') || false;
            configuredItem.lockN = false;
            configuredItem.lockR = false;

            configuredItem.id = item.id;
            configuredItem.direction = {value: item.direction, editedValue: item.direction};
            let name = _.find(this.dataTypes, {id: item.data_type_id}).name;
            configuredItem.dataTypeId = {
                value: item.data_type_id,
                editedValue: item.data_type_id,
                name
            };
            let valueR = item.value_r ? item.value_r : 0;
            configuredItem.valueR = {
                value: this.convertToLocalizedFloat(valueR,this.locale),
                editedValue: this.convertToLocalizedFloat(valueR,this.locale)
            };
            let valueN = item.value_n ? item.value_n : 0;
            configuredItem.valueN = {
                value: this.convertToLocalizedFloat(valueN,this.locale),
                editedValue: this.convertToLocalizedFloat(valueN,this.locale),
            };
            configuredItem.descriptionOther = {
                value: item.description_other,
                editedValue: item.description_other
            };
            configuredItem.descriptionId = {
                value: item.description_id,
                editedValue: item.description_id
            };
            configuredItem.startYear = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endYear = {
                value: endDateInit,
                editedValue: endDateInit
            };
            configuredItem.approvedBy = {value: item.approved_by, editedValue: item.approved_by};
            configuredItem.isApproved = {value: item.is_approved, editedValue: item.is_approved};

            for (let key in configuredItem) {
                // If a field editable it has to includes controller fields
                if (
                    configuredItem[key] &&
                    typeof configuredItem[key] === 'object' &&
                    configuredItem[key].hasOwnProperty('value')
                ) {
                    configuredItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    configuredItem[key].hasWarn = false;
                    configuredItem[key].warnMessage = this.$t('required');
                }
            }

            return configuredItem;
        },

        // Bind goals object array to use in dom
        bindItems(goals) {
            this.goals = goals
                .filter(goal => _.find(this.dataTypes, {id: goal.data_type_id}))
                .map(this.prepareItem);
            _.each(this.goals, goal => {
                this.setTotalsByDataType(goal.dataTypeId.editedValue, goal, false);
            });
            return this.calculateLastColumnWidth();
        },

        listSiteGoals() {
            this.isLoaded = false;
            this.$Progress.start();
            return this.axios
                .get(`/goals/${this.selectedSite.id}?${qs.stringify({year: this.year})}`)
                .then(({data}) => {
                    this.descriptions = [
                        {description_text: '-', id: null, disabled: true},
                        ...data.descriptions
                    ];
                    _.each(this.descriptions, description => {
                        description.description_text = this.$t(description.description_text)
                    });
                    this.siteProperties = data.siteProperties;
                    this.units = data.units;
                    this.rawItems = data.goals;
                    this.allTotals = data.allTotals;
                    this.bindItems(this.rawItems);
                    this.isLoaded = true;
                    return this.$Progress.finish();
                });
        },
        calculateLastColumnWidth() {
            return this.$nextTick().then(() => {
                let element = document.getElementById('goal-last-column');
                if (element) {
                    this.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init() {
            this.selectedSite = _.find(this.sites, {
                id: Number(_.get(this.route.params, 'site_id'))
            });
            this.$store.state.siteId = _.get(this.route.params, 'site_id')
                ? _.get(this.route.params, 'site_id')
                : null;
            this.dataTypes = this.$store.state.dataTypes.filter(dataType => {
                return this.selectedSite.dataTypes.indexOf(dataType.id) > -1;
            });
            this.dataTypesDropdown = [];
            this.dataTypes.forEach(dataType => {
                this.dataTypesDropdown.push({value: dataType.id, text: this.$t(dataType.name)});
            });
            this.filterDeletedDataTypes(this.selectedSite.id);
            this.listSiteGoals();
        }
    },
    created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
};
</script>

<style lang="scss" scoped>
.fadere-enter-active {
    opacity: 1;
    transition: opacity 0.6s ease;
}
.fadere-enter,
.fadere-leave-to,
.fadere-leave-active {
    opacity: 0;
}
th {
    min-width: 10em;
}
.edit-column {
    position: static;
}

.scroll-content tfoot,
.scroll-content tfoot th,
.scroll-content tfoot td {
  position: sticky;
  bottom: 0;
  border-bottom-color: #ddd;
  background: white;
  z-index:2;
}

</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "HEDEFLER",
            "dataTypeColumn": "Veri Tipi",
            "startYearColumn": "Baz Yıl",
            "endYearColumn": "Hedef Yıl",
            "goalTypeColumn": "Hedef Tipi",
            "goalRatioColumn": "Hedeflenen (%)",
            "goalColumn": "Hedeflenen Tüketim",
            "actualColumn": "Gerçekleşen Tüketim",
            "descriptionColumn": "Açıklama",
            "confirmationColumn": "Onay Durumu",
            "currentSituation": "Mevcut Durumu Koruma",
            "decrease": "Azaltma",
            "raise": "Arttırma",
            "noConfirm": "Beklemeye Al",
            "actualColumnRatio": "Gerçekleşen (%)",
            "perPerson": "/kişi",
            "perM2Person": "/m2.kişi",
            "Şube alanında artış": "Şube alanında artış",
            "Şube alanında azalış": "Şube alanında azalış",
            "Çalışan sayısında artış": "Çalışan sayısında artış",
            "Çalışan sayısında azalış": "Çalışan sayısında azalış",
            "Enerji tüketen ekipmanlarda artış (Ör: ATM, klima)": "Enerji tüketen ekipmanlarda artış (Örn: ATM, klima)",
            "Enerji tüketen ekipmanlarda azalış (Ör: ATM, klima)": "Enerji tüketen ekipmanlarda azalış (Örn: ATM, klima)",
            "Hava sıcaklığında bir önceki yıla kıyasla artış": "Hava sıcaklığında bir önceki yıla kıyasla artış",
            "Hava sıcaklığında bir önceki yıla kıyasla azalış": "Hava sıcaklığında bir önceki yıla kıyasla azalış",
            "Şube personel farkındalığının düşük olması": "Şube personel farkındalığının düşük olması",
            "Şube iş hacminin artması": "Şube iş hacminin artması",
            "Şube iş hacminin azalması": "Şube iş hacminin azalması"
        },
        "en": {
            "title": "GOALS",
            "dataTypeColumn": "Data Type",
            "startYearColumn": "Base Year",
            "endYearColumn": "Target Year",
            "goalTypeColumn": "Target Type",
            "goalRatioColumn": "Targeted (%)",
            "goalColumn": "Targeted",
            "actualColumn": "Actual",
            "descriptionColumn": "Description",
            "confirmationColumn": "Confirmation Status",
            "currentSituation": "No Change",
            "decrease": "Decrease",
            "raise": "Increase",
            "noConfirm": "No Confirm",
            "actualColumnRatio": "Actual %",
            "perPerson": "/person",
            "perM2Person": "/m2.kişi",
            "Şube alanında artış": "Increasing in the location area",
            "Şube alanında azalış": "Decreasing in the location area",
            "Çalışan sayısında artış": "Increasing in the number of employees",
            "Çalışan sayısında azalış": "Decreasing in the number of employees",
            "Enerji tüketen ekipmanlarda artış (Ör: ATM, klima)": "Increasing in energy consuming equipment (Ex: ATM, air conditioner)",
            "Enerji tüketen ekipmanlarda azalış (Ör: ATM, klima)": "Decreasing in energy consuming equipment (Ex: ATM, air conditioner)",
            "Hava sıcaklığında bir önceki yıla kıyasla artış": "Increasing in air temperature compared to the previous year",
            "Hava sıcaklığında bir önceki yıla kıyasla azalış": "Decreasing in air temperature compared to the previous year",
            "Şube personel farkındalığının düşük olması": "Low awareness of location employees",
            "Şube iş hacminin artması": "Increasing location business volume",
            "Şube iş hacminin azalması": "Decreasing location business volume"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Goal/Detail.vue